import moment from "moment";

export const parseTypeWithDefaultValue = (field, value) => {
  const type = field.DATATYPE;

  switch (type) {
    /*(1)*/ case "INT":
    case "INT UNSIGNED":
    case "BIGINT":
    case "BIGINT UNSIGNED":
      return { valid: true, result: parseInt(value || 0) };
    /*(2)*/ case "DECIMAL":
    case "DECIMAL UNSIGNED":
      return { valid: true, result: parseFloat(value || 0) };
    /*(3)*/ case "BOOL":
      return { valid: true, result: value || false };

    /*(4)*/ case "DATE":
    case "DATETIME":
      let date = moment.utc(value).toDate();

      if (!moment.isDate(date)) {
        date = moment(value, field.FORMAT).format();
      }

      if (moment.isDate(date) && moment(date).isValid()) {
        return { valid: true, result: date };
      } else {
        return { valid: true, reason: new Date() };
      }
    /*(5)*/ case "TEXT":
      const stringifiedValue = value ? value.toString() : "";
      return { valid: true, result: stringifiedValue };
    /*(6)*/ case "CHAR":
      const charifiedValue = value.toString();
      return { valid: true, result: charifiedValue };
    /*(7)*/ case "PHONE":
    case "EMAIL":
      return { valid: true, result: value };
    case "FILE":
      try {
      } catch {}
      return { valid: true, result: value };

    /*(8)*/ default:
      return { valid: false };
  }
};
